import { t as tr } from './i18n';
/**
 * Rolurile din firmă. Trei roluri de lucru și, separat, administratorul:
 * - Achiziții: cereri, oferte, comenzi; comenzile peste prag merg la aprobare;
 * - Aprobator (director de achiziții, CFO): aprobă comenzile și poate face tot
 *   ce face Achiziții;
 * - Șantier (șeful de șantier): trimite necesarul de materiale, îi urmărește
 *   stadiul și trece livrările cu avizul (Achizițiile le confirmă); nu vede
 *   prețuri sau oferte. Nu ocupă loc în pachet și nu poate fi administrator;
 * - Administrator (oricare dintre ei): datele firmei, echipa, pachetul.
 *
 * Utilizatorii de dinainte de roluri sunt Aprobator și Administrator: exact
 * drepturile pe care le aveau.
 */

export type Role = 'buyer' | 'approver' | 'site';

export const ROLES: readonly { id: Role; label: string; hint: string }[] = [
  {
    id: 'buyer',
    get label() {
      return tr('Achiziții');
    },
    get hint() {
      return tr('cereri, oferte și comenzi');
    },
  },
  {
    id: 'approver',
    get label() {
      return tr('Aprobator');
    },
    get hint() {
      return tr('aprobă comenzile; face și tot ce face Achiziții');
    },
  },
  {
    id: 'site',
    get label() {
      return tr('Șantier');
    },
    get hint() {
      return tr(
        'trimite necesarul, vede unde a ajuns și trece livrările cu avizul, fără prețuri; nu ocupă loc în pachet',
      );
    },
  },
];

export const isRole = (v: string): v is Role => v === 'buyer' || v === 'approver' || v === 'site';

/** Omul de pe șantier: necesarul și livrările. */
export const isSiteRole = (role: string): boolean => role === 'site';

export const SITE_ADMIN_MESSAGE = 'Un cont de șantier nu poate fi administrator. Alege alt rol întâi.';

export const roleLabel = (role: string): string => ROLES.find((r) => r.id === role)?.label ?? role;

export const ADMIN_ONLY_MESSAGE = 'Doar un administrator al contului poate face asta.';

export const LAST_ADMIN_MESSAGE =
  'Contul trebuie să aibă cel puțin un administrator. Fă pe altcineva administrator întâi.';
